module.exports = __webpack_public_path__ + "static/media/foto3.17482a9a.png";